import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-j',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-j.component.html',
  styleUrl: './section-j.component.css'
})
export class SectionJComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection12 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionJForm: FormGroup = new FormGroup([]);

  radioQuestions = [
    {
      id: 'positive_relationship_adult',
      questionText: 'Does the student have at least one healthy relationship with an adult in school with whom he/she can confide in and trust? *',
      formControlName: 'positive_relationship_adult',
      infoFormControlName: 'positive_relationship_adult_contact',
      label: 'With whom? *'
    },
    {
      id: 'positive_relationship_outside',
      questionText: "Does the student have at least one healthy relationship with an adult outside of school with whom he/she can confide in and trust? *",
      formControlName: 'positive_relationship_outside',
      infoFormControlName: 'positive_relationship_outside_contact',
      label: 'With whom? *'
    },
    {
      id: 'positive_peer_relationship',
      questionText: 'Does the student have positive peer relationships? *',
      formControlName: 'positive_peer_relationship',
      infoFormControlName: 'positive_peer_relationship_contact',
      label: 'With whom? *'
    },
    {
      id: 'student_raise_concern',
      questionText: "Has the student previously come to someone's attention or raised concern in a way that suggested he/she needed intervention or supportive services: *",
      formControlName: 'student_raise_concern',
      infoFormControlName: 'student_raise_concern_information',
      label: 'Please explain: *'
    },
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
      group[question.infoFormControlName] = new FormControl({ value: this.fullTeamAssessmentData?.[question.infoFormControlName] || '', disabled: this.fullTeamAssessmentData?.[question.infoFormControlName] ? false: true });
    });
    group['j_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.j_additional_info) || this.yesNo.No, Validators.required);    
    
    this.sectionJForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.sectionJForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.sectionJForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSectionJ(): void {
    if (this.sectionJForm.valid) {
      this.onSaveSection12.emit(this.sectionJForm.value);
    }
  }

}
